import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';
import { v4 as uuidv4 } from 'uuid';

import { ticketAtom } from '@/pages/Ticket';

const TemplateTicketExternalThreats = () => {
  const [{ ticket_external_threats }] = useAtom(ticketAtom);

  return (
    <>
      <Divider sx={{ borderWidth: '1px' }} />
      <Typography variant="h5">External Threats</Typography>
      <TableContainer>
        <Table style={{ display: 'table', tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 0, width: '10rem' }}>Address Type</TableCell>
              <TableCell sx={{ py: 0 }}>Source</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* TODO: api return this list in asc order by id */}
            {ticket_external_threats?.map((threat) => (
              <TableRow key={uuidv4()}>
                <TableCell
                  sx={{
                    py: 1,
                    textTransform: 'uppercase'
                  }}
                >
                  {threat.address_type}
                </TableCell>
                <TableCell
                  sx={{
                    py: 1,
                    wordWrap: 'break-word'
                  }}
                >
                  {threat.source}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TemplateTicketExternalThreats;
